
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.757 19.484l-3.945-4.208a6.949 6.949 0 001.57-4.412c0-3.785-3.001-6.864-6.69-6.864C7.001 4 4 7.08 4 10.864s3.002 6.863 6.691 6.863a6.505 6.505 0 003.834-1.242l3.974 4.24a.856.856 0 001.234.025.913.913 0 00.024-1.266zM10.69 5.791c2.727 0 4.946 2.275 4.946 5.073 0 2.797-2.219 5.073-4.946 5.073s-4.945-2.276-4.945-5.073c0-2.798 2.218-5.073 4.945-5.073z","fill-rule":"nonzero"}})])
          )
        }
      }
    